/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckChecklistStatus {
    ON_HOLD = 'ON_HOLD',
    ACTIVE = 'ACTIVE',
    FINALIZED = 'FINALIZED'
}


export function instanceOfPaxCheckChecklistStatus(value: any): boolean {
    for (const key in PaxCheckChecklistStatus) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckChecklistStatus, key)) {
            if (PaxCheckChecklistStatus[key as keyof typeof PaxCheckChecklistStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckChecklistStatusFromJSON(json: any): PaxCheckChecklistStatus {
    return PaxCheckChecklistStatusFromJSONTyped(json, false);
}

export function PaxCheckChecklistStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckChecklistStatus {
    return json as PaxCheckChecklistStatus;
}

export function PaxCheckChecklistStatusToJSON(value?: PaxCheckChecklistStatus | null): any {
    return value as any;
}

export function PaxCheckChecklistStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckChecklistStatus {
    return value as PaxCheckChecklistStatus;
}

